import * as React from 'react';
import styled from 'styled-components';

interface IEmailIcon {
  color?: string;
  className?: string;
}

export const EmailIcon: React.FC<IEmailIcon> = ({
  color = 'black',
  className,
}) => {
  return (
    <StyledOldIcon className={className}>
      <svg
        width="30"
        height="19"
        viewBox="0 0 30 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="19" rx="2" fill="#8F5637" />
        <path
          d="M3 3L10.6364 10M27 3L19.3636 10M19.3636 10L16.3514 12.7612C15.7098 13.3493 15.389 13.6434 15 13.6434C14.611 13.6434 14.2902 13.3493 13.6486 12.7612L10.6364 10M19.3636 10L27 17M10.6364 10L3 17"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </StyledOldIcon>
  );
};

const StyledOldIcon = styled.div`
  svg {
    rect {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`;
